import React, { Component } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import Scroll from 'react-scroll';
import { DIST_URL } from '../../../../constants/api';


export default class Mark extends Component {

  scrollToContactForm(){
    var scroller = Scroll.scroller;
    scroller.scrollTo('myContactForm', {
      duration: 1500,
      delay: 100,
      smooth: true,
    })
  }

  render () {

  	const { img, address, name, code, tel } = this.props

   	var style = {
      width: 275,
      height: 320,
      display: "flex",
    	justifyContent: "center",
    	padding: 0
    }

    var scroll = Scroll.animateScroll;

  	const popoverSucursal = (
		  <Popover id="popover-positioned-top" style={style}>
		  	<div className="popover-img">
		  		<img src={img} alt="LJRamos" />
		  	</div>

        <div className="pop-info">
          <div className="item-sucursal">
            <div>
              <h1> {name} </h1>
              <div className="items-align">
                <i className="fa fa-map-marker"></i>
                <h3> {address} </h3>
              </div>
              <div className="items-align">
                <i className="fa fa-mobile"></i>
                <h3> ({code}) -  { tel.replace(/(\d{4})(\d{4})/, "$1-$2") } </h3>
              </div>
              <div className="bar-divisor sucursal"></div>
              <button className="btn btn-popover" onClick={this.scrollToContactForm}> Contacto </button>
            </div>
          </div>
        </div>
		  </Popover>
		);

    return (
    	<OverlayTrigger trigger="click" rootClose placement="top" overlay={popoverSucursal}>
	      <img src={DIST_URL+'/assets/images/maps-mark.png'} alt="LJRamos" />
	    </OverlayTrigger>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageBranches/components/Map/mark.js